import { render, staticRenderFns } from "./AddFacility.vue?vue&type=template&id=1da6a1e2&scoped=true"
import script from "./AddFacility.vue?vue&type=script&lang=js"
export * from "./AddFacility.vue?vue&type=script&lang=js"
import style0 from "./AddFacility.vue?vue&type=style&index=0&id=1da6a1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da6a1e2",
  null
  
)

export default component.exports